module.exports = __webpack_public_path__ + "img/imagen4.d5d38f75.png";